import { useEffect, useRef, useState } from 'react';
import OverviewCard from '../../components/OverviewCard';
import axios from 'axios';
import Admin from '../../api/Admin';
import State from '../../api/Laws';
import TransactionTable from '../../components/Admin/TransactionTable';
import Paginator from '../../components/Paginator';
import { IoCloseSharp } from 'react-icons/io5';
import { CiCalendarDate } from 'react-icons/ci';
import Button from '../../components/FormComponents/Button';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import { checkAdmin } from '../../utils/session';
import { useNavigate } from 'react-router-dom';
import debounce from '../../utils/debounce';
import { Period } from '../../utils/period';

function AdminTransaction() {
  const navigate = useNavigate();

  const [transactions, setTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalLawsSold, setTotalLawsSold] = useState(0);
  const [totalTransactions, setTotalTransactions] = useState(0);

  const [filter] = useState('');
  const [searchResult] = useState([]);
  const [filterResult] = useState([]);
  const [response, setResponse] = useState({ status: '', message: '' });
  const [id, setId] = useState('');

  const [pageLimit] = useState(5);
  const [perPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  let currentUsers = [];
  const [pageGroup, setPageGroup] = useState(() =>
    new Array(pageLimit).fill().map((_, index) => index + 1),
  );

  const [filterLloading, setFilterLloading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  let fromDateNew = fromDate ? new Date(fromDate) : '';
  let toDateNew = toDate ? new Date(toDate) : '';
  fromDateNew =
    fromDateNew &&
    `${fromDateNew.getFullYear()}-${
      fromDateNew.getMonth() + 1 < 10 ? '0' : ''
    }${fromDateNew.getMonth() + 1}-${fromDateNew.getDate()}`;

  toDateNew =
    toDateNew &&
    `${toDateNew.getFullYear()}-${toDateNew.getMonth() + 1 < 10 ? '0' : ''}${
      toDateNew.getMonth() + 1
    }-${toDateNew.getDate()}`;
  const [showCalendar, setShowCalendar] = useState(false);

  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const [showOverlay, setShowOverlay] = useState(false);
  const [states, setStates] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedStateForExport, setSetSelectedStateForExport] = useState('');
  const [, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Ref for date boxes
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const [isExportVisible, setIsExportVisible] = useState(false);

  const toggleExport = () => {
    setIsExportVisible(!isExportVisible);
    if (isDropdownVisible) {
      setDropdownVisible(false);
    }
  };

  const handleExport = async () => {
    setIsExportVisible(false);
    setFilterLloading(true);

    const formattedFromDate = fromDate ? Period.formatISO(fromDate) : '';
    const formattedToDate = toDate ? Period.formatISO(toDate) : '';

    try {
      // Build query params dynamically
      const params = [];
      if (formattedFromDate)
        params.push(`from_date=${encodeURIComponent(formattedFromDate)}`);
      if (formattedToDate) params.push(`to_date=${encodeURIComponent(formattedToDate)}`);
      if (selectedStateForExport)
        params.push(`state_name=${encodeURIComponent(selectedStateForExport)}`);
      const queryString = params.length ? `?${params.join('&')}` : '';

      // First request to get the download link
      const data = await Admin.exportTransactions(queryString);

      const downloadUrl = URL.createObjectURL(data);

      // Create and trigger download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `transactions-${new Date().getTime()}.xlsx`; // Dynamic filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting file: ', error);
      // Add error handling here - maybe show a toast/notification
    } finally {
      setFilterLloading(false);
      setFromDate(null);
      setToDate(null);
      setSelectedState('');
    }
  };

  // Toggle the calendar and overlay
  const toggleCalendar = (dateType, e) => {
    e.stopPropagation();

    // Determine which date box triggered the event
    const ref = dateType === 'from' ? fromDateRef.current : toDateRef.current;

    // Get the position of the clicked date box
    const rect = ref.getBoundingClientRect();
    setCalendarPosition({
      top: rect.bottom + window.scrollY, // Position below the date box
      left: rect.left, // Align to the left of the date box
    });
    if (dateType === 'from') {
      setShowCalendar('from');
    } else if (dateType === 'to') {
      setShowCalendar('to');
    }
    setShowOverlay(true);
  };

  const handleDateSelection = (dateType, e) => {
    console.log(new Date(e).toDateString().substring(4, 16));
    if (dateType === 'from') {
      setFromDate(new Date(e).toDateString().substring(4, 16));
    } else {
      setToDate(new Date(e).toDateString().substring(4, 16));
    }
    setShowOverlay(false);
  };

  const closeCalendar = () => {
    setShowOverlay(false);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
    if (isExportVisible) {
      setIsExportVisible(false);
    }
  };

  const handleApplyFilter = async () => {
    if (fromDate === null || toDate === null) {
      return;
    }
    await getTransactions(1, fromDateNew, toDateNew, '', selectedState);
    await getTotalSales(fromDateNew, toDateNew);
  };

  const changePage = (page) => {
    setCurrentPage(page);
    getTransactions(page, fromDateNew, toDateNew, searchTerm, selectedState);
    setPageGroup(getPageGroup(page));
  };

  const clearFilter = () => {
    setFromDate('');
    setToDate('');
    setSearchTerm('');
    setSelectedState('');
    getTransactions(1, '', '', '', '');
    getTotalSales();
  };

  const getPageGroup = (page) => {
    let start = Math.floor((page - 1) / pageLimit) * pageLimit;
    const newGroup = new Array(pageLimit).fill().map((_, index) => start + index + 1);
    return newGroup;
  };

  const getStates = async () => {
    setLoading(true);
    try {
      const { data: states } = await State.fetchAllStates();

      setStates(states);

      // states.forEach((state) => {
      //   stateArray.push({ id: state.id, state: state.name });
      // });
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading(false);
      // getUsers(currentPage);
    }
  };

  const getTransactions = async (
    page,
    from_date = '',
    to_date = '',
    search = '',
    state_name = '',
  ) => {
    setFilterLloading(true);
    try {
      const params = {
        page,
        ...(from_date && { from_date }),
        ...(to_date && { to_date }),
        ...(search && { search }),
        ...(state_name && state_name !== 'All' && { state_name }),
      };

      const responseData = await Admin.getTransactions(params);
      const {
        data: { data },
      } = responseData;
      // console.log(response.data.data);
      setTotalTransactions(responseData.data.total);
      setCurrentPage(responseData.data.current_page);
      setTransactions(data);
    } catch (error) {}
    setFilterLloading(false);
    setDropdownVisible(false);
  };

  useEffect(() => {
    const { session, token } = checkAdmin();
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    if (!session) {
      navigate('login');
    }
  }, [navigate]);

  const getTotalSales = async (from_date = '', to_date = '', state_name = '') => {
    try {
      const params = {
        ...(from_date && { from_date }),
        ...(to_date && { to_date }),
        ...(state_name && { state_name }),
      };
      const { data } = await Admin.getTotalSales(params);
      const salesData = Array.isArray(data) ? data[0] : data;

      setTotalAmount(
        (salesData?.total_amount || 0).toLocaleString('en-NG', {
          style: 'currency',
          currency: 'NGN',
        }),
      );
      setTotalLawsSold(salesData?.laws_sold || 0);
    } catch (error) {
      console.error('Error fetching total sales: ', error);
    }
  };

  const searchUser = (string) => {
    setSearchTerm(string.toLowerCase());
    debounce(() => getTransactions(1, '', '', string.toLowerCase()), selectedState);
  };

  const closeOptions = () => {
    setId(null);
  };

  useEffect(() => {
    getTransactions(1);
    getTotalSales();
    getStates();
  }, []);

  useEffect(() => {
    getTransactions(1, fromDateNew, toDateNew, '', selectedState);
    getTotalSales(fromDateNew, toDateNew, selectedState === 'All' ? '' : selectedState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState]); // intentionally omitting dates - applied manually via handleApplyFilter

  currentUsers = searchResult.length ? searchResult : transactions;

  return (
    <div className="transaction">
      <div
        className={`transaction__response ${
          response.status
            ? response.status?.toString().includes('20')
              ? 'transaction__response--success'
              : 'transaction__response--error'
            : ''
        }`}
        onClick={() => setResponse({ status: '' })}
      >
        {response.message || 'Action Successful'} &#x24E7;
      </div>

      <div className="transaction__transactions">
        <div className="transaction__actions">
          <div className="transaction__view">
            <div className="transaction__search">
              <span className="transaction__icon transaction__icon--search"></span>
              <input
                type="text"
                name="search"
                id="search"
                placeholder="Search"
                className="transaction__input"
                value={searchTerm}
                onChange={(e) => searchUser(e.target.value)}
              />
            </div>
            <div className="transaction__filter" onClick={toggleDropdown}>
              <img src="/images/filter2.svg" alt="filter" />
              <span className="transaction__select">Date Filter</span>
              {isDropdownVisible && (
                <div
                  className="transaction__filter--modal filterDropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="title">
                    <p>Filter</p>{' '}
                    <IoCloseSharp onClick={toggleDropdown} cursor="pointer" size="20px" />
                  </div>

                  <div className="filterDate">
                    <p>Start Date</p>

                    <div
                      className="dateBox"
                      ref={fromDateRef}
                      onClick={(e) => toggleCalendar('from', e)}
                    >
                      {fromDate ? fromDate : 'Select a date'}{' '}
                      <CiCalendarDate size="25px" />
                    </div>
                  </div>
                  <div className="filterDate">
                    <p>End Date</p>

                    <div
                      className="dateBox"
                      ref={toDateRef}
                      onClick={(e) => toggleCalendar('to', e)}
                    >
                      {toDate ? toDate : 'Select a date'} <CiCalendarDate size="25px" />
                    </div>
                  </div>

                  <Button
                    text="Apply Filter"
                    loading={filterLloading}
                    onClick={(e) => handleApplyFilter()}
                  />

                  {/* Calendar overlay */}
                  {showOverlay && (
                    <div className="calendar-overlay" onClick={closeCalendar}>
                      <div
                        className="calendar-container"
                        style={{
                          position: 'absolute',
                          top: calendarPosition.top,
                          left: calendarPosition.left,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="calendar-title">
                          <p>Calendar</p>
                          <IoCloseSharp
                            onClick={closeCalendar}
                            cursor="pointer"
                            size="20px"
                          />
                        </div>
                        {showCalendar === 'from' && (
                          <DayPicker
                            mode="single"
                            disabled={{ after: new Date() }}
                            selected={fromDate}
                            onDayClick={(e) => handleDateSelection('from', e)}
                            captionLayout="label"
                            footer={fromDate ? `Selected: ${fromDate}` : 'Pick a day.'}
                            defaultMonth={fromDate}
                            endMonth={new Date()}
                            numberOfMonths={12}
                            pagedNavigation
                          />
                        )}
                        {showCalendar === 'to' && (
                          <DayPicker
                            mode="single"
                            disabled={{
                              before: new Date(fromDate),
                              after: new Date(),
                            }}
                            selected={new Date(toDate)}
                            onDayClick={(e) => handleDateSelection('to', e)}
                            captionLayout="label"
                            footer={toDate ? `Selected: ${toDate}` : 'Pick a day'}
                            defaultMonth={toDate}
                            endMonth={new Date()}
                            numberOfMonths={12}
                            pagedNavigation
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <select
              className="transaction__state-dropdown"
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
            >
              <option value="" disabled>
                Select State
              </option>
              <option value="All">All</option>
              {states.length
                ? states?.map((state) => (
                    <option key={state.id} value={state.mname}>
                      {state.name}
                    </option>
                  ))
                : ''}
            </select>
            <span className="transaction__clear-filter" onClick={() => clearFilter()}>
              Clear Filters
            </span>
          </div>
          <div className="client__export" onClick={toggleExport}>
            <span className="client__icon--export"></span>
            <span>Export</span>
            {isExportVisible && (
              <div
                className="transaction__filter--modal exportDropdown"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="title">
                  <p>Filter</p>{' '}
                  <IoCloseSharp onClick={toggleExport} cursor="pointer" size="20px" />
                </div>

                <div className="filterDate">
                  <p>Start Date</p>

                  <div
                    className="dateBox"
                    ref={fromDateRef}
                    onClick={(e) => toggleCalendar('from', e)}
                  >
                    {fromDate ? fromDate : 'Select a date'} <CiCalendarDate size="25px" />
                  </div>
                </div>
                <div className="filterDate">
                  <p>End Date</p>

                  <div
                    className="dateBox"
                    ref={toDateRef}
                    onClick={(e) => toggleCalendar('to', e)}
                  >
                    {toDate ? toDate : 'Select a date'} <CiCalendarDate size="25px" />
                  </div>
                </div>

                <select
                  className="transaction__state-dropdown"
                  value={selectedState}
                  onChange={(e) => setSetSelectedStateForExport(e.target.value)}
                >
                  <option value="" disabled>
                    All States
                  </option>
                  {states.length
                    ? states?.map((state) => (
                        <option key={state.id} value={state.mname}>
                          {state.name}
                        </option>
                      ))
                    : ''}
                </select>

                <Button
                  text="Export"
                  loading={filterLloading}
                  onClick={(e) => handleExport()}
                />

                {/* Calendar overlay */}
                {showOverlay && (
                  <div className="calendar-overlay" onClick={closeCalendar}>
                    <div
                      className="calendar-container"
                      style={{
                        position: 'absolute',
                        top: calendarPosition.top,
                        left: calendarPosition.left,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="calendar-title">
                        <p>Calendar</p>
                        <IoCloseSharp
                          onClick={closeCalendar}
                          cursor="pointer"
                          size="20px"
                        />
                      </div>
                      {showCalendar === 'from' && (
                        <DayPicker
                          mode="single"
                          disabled={{ after: new Date() }}
                          selected={fromDate}
                          onDayClick={(e) => handleDateSelection('from', e)}
                          captionLayout="label"
                          footer={fromDate ? `Selected: ${fromDate}` : 'Pick a day.'}
                          defaultMonth={fromDate}
                          endMonth={new Date()}
                          numberOfMonths={12}
                          pagedNavigation
                        />
                      )}
                      {showCalendar === 'to' && (
                        <DayPicker
                          mode="single"
                          disabled={{
                            before: new Date(fromDate),
                            after: new Date(),
                          }}
                          selected={new Date(toDate)}
                          onDayClick={(e) => handleDateSelection('to', e)}
                          captionLayout="label"
                          footer={toDate ? `Selected: ${toDate}` : 'Pick a day'}
                          defaultMonth={toDate}
                          endMonth={new Date()}
                          numberOfMonths={12}
                          pagedNavigation
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="transaction__cards">
          <OverviewCard
            image="/images/total-users.svg"
            color="purple"
            label="Total Number of Laws Sold"
            text={totalLawsSold}
          />
          <OverviewCard
            image="/images/total-users.svg"
            color="purple"
            label="Total Amount"
            text={totalAmount}
          />
        </div>
        <div className="transaction__table">
          {filterLloading ? (
            <Loader />
          ) : transactions.length === 0 ? (
            <NoData />
          ) : (
            <TransactionTable
              data={
                filter !== ''
                  ? filterResult
                  : searchResult.length
                    ? searchResult
                    : transactions
              }
              setResponse={setResponse}
              id={id}
              setId={setId}
              closeOptions={closeOptions}
            />
          )}
          {currentUsers && (
            <div className="transaction__paginator">
              <Paginator
                perPage={perPage}
                totalLaws={searchResult?.length || totalTransactions}
                changePage={changePage}
                currentPage={currentPage}
                pageGroup={pageGroup}
                setPageGroup={setPageGroup}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminTransaction;
